import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../lib/cn';

interface AppCardProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
  isHoverable?: boolean;
  isPressable?: boolean;
}

/**
 * Compound card component with optional header and footer slots.
 */
export function AppCard({
  children,
  className,
  footer,
  isHoverable = false,
  isPressable = false,
  title,
  ...props
}: AppCardProps) {
  return (
    <div
      className={cn(
        'overflow-hidden rounded-xl border border-iron-800 bg-iron-900 shadow-[0_10px_30px_rgba(0,0,0,0.18)]',
        isHoverable &&
          'transition-transform transition-shadow hover:-translate-y-0.5 hover:shadow-[0_16px_36px_rgba(0,0,0,0.24)]',
        isPressable && 'cursor-pointer',
        className,
      )}
      {...props}
    >
      {title && <div className="border-b border-iron-800 px-5 py-4 text-iron-100">{title}</div>}
      <div className="px-5 py-4">{children}</div>
      {footer && <div className="border-t border-iron-800 px-5 py-4">{footer}</div>}
    </div>
  );
}
